import { Pie } from 'react-chartjs-2';
import { useTheme } from '@partiu/ui/contexts/ThemeProvider.tsx';
import { CircularProgress } from '@chakra-ui/react';
import { useMemo } from 'react';

export function CategoryUsageGraph({ data, height }: { data?: any; height: string }) {
  const { colors } = useTheme();
  let cleanData = useMemo(() => {
    if (!data) return [];
    const maxCategories = 10;
    let d = data.filter((d: any) => d[1] > 0).sort((a: any, b: any) => a[1] - b[1]);

    if (d.length > maxCategories) {
      let others = d.slice(0, d.length - maxCategories).reduce((a: number, b: Record<string, any>) => a + b[1], 0);
      let bigCategories = d.slice(d.length - maxCategories).filter((c: any) => c[1] > others);
      d.slice(d.length - maxCategories)
        .filter((c: any) => c[1] < others)
        .forEach((c: any) => (others += c[1]));
      d = [...bigCategories, ['Outros', others]];
    }

    return d;
  }, [data]);

  if (!data) return <CircularProgress isIndeterminate />;

  return (
    <Pie
      height={height}
      width="100%"
      data={{
        labels: cleanData.map((d: any) => d[0]),
        datasets: [
          {
            label: 'Utilização',
            data: cleanData.map((d: any) => d[1]),
            backgroundColor: colors.graphColors,
          },
        ],
      }}
    />
  );
}
